import React from 'react';

function SaveStatus({ lastSaveTime, isSavingZoho }) {
  return (
    <div className="save-status">
      {isSavingZoho && <span className="save-indicator zoho">Syncing to Zoho...</span>}
      {lastSaveTime && (
        <span className="save-indicator saved">
          Last saved: {lastSaveTime.toLocaleTimeString('da-DK')}
        </span>
      )}
    </div>
  );
}

export default SaveStatus;
